<template lang="pug">
  div.checkbox-list(:class="{'is-qs-hidden': hasCondition && !checkCondition}")
    div.checkbox-list__label(v-if='required')
      | {{label + ' '}}
      span.input-field__label-tooltip * <span>Обязательное поле</span>
    div.checkbox-list__label(v-else) {{label}}
    template(v-for="(el, idx) in formElements")
      template(v-if="hasRowColumns")
        div.form-row(:class="{'is-multi-cols': el.length > 1}")
          template(v-for="col in el")
            input-field(
              :question_sub="col.question_sub"
              :text="isFilled(col.question_sub)"
              :event="'onChange'"
              :placeholder="col.placeholder"
              :label="col.label"
              :class="['form-row__item']"
              :output_type="col.insert_type.name"
              :key="col.question"
              v-bind="{'style': el.length > 1 ? {width: `calc((100% / ${el.length}) - 1em)`}: null}")
      template(v-else)
        div.form-row
          input-field(
            :question_sub="el.question_sub"
            :event="'onChange'"
            :placeholder="el.placeholder"
            :text="isFilled(el.question_sub)"
            :label="el.label"
            :class="['form-row__item']"
            :output_type="el.insert_type.name"
            :key="el.question")
</template>

<script>
  // vendor
  import _find from 'lodash/find';

  // mixins
  import fieldProps from '@/mixins/fieldProps';
  import combineFormRows from '@/mixins/combineFormRows';
  import checkConditions from '@/mixins/questionConditions';

  // components
  import InputField from '@/components/UI/InputField/InputField.vue';

  export default {
    name: 'InputFieldGroup',
    mixins: [fieldProps, combineFormRows, checkConditions],
    components: {
      'input-field': InputField
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      filled: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      formElements () {
        return this.combineFormRows(this.$props.options);
      }
    },
    methods: {
      isFilled (id) {
        let result = null;
        result = _find(this.$props.filled, { 'question_sub': id });
        return result ? result.text : '';
      },
      changeHandler (data) {
        if (data) {
          data.pollId = this.$props.pollId;
          this.$store.dispatch('answers/addRemoveAnswer', data);
        }
      }
    },
    mounted () {
      this.$on('onChange', this.changeHandler);
    },
    data () {
      return {
        inputVal: []
      }
    }
  }
</script>

<style lang="scss" src="./assets/checkbox-list.scss"></style>
